import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["all", "box", "submit", "submitLabel"];

  connect() {
    this.refresh();
  }

  toggleAll() {
    const checked = this.allTarget.checked;
    this.boxTargets.forEach((box) => {
      box.checked = checked;
    });
    this.refresh();
  }

  refresh() {
    const boxes = this.boxTargets;
    const checked = boxes.filter((box) => box.checked).length;

    if (this.hasAllTarget) {
      this.allTarget.checked = boxes.length > 0 && checked === boxes.length;
      this.allTarget.indeterminate = checked > 0 && checked < boxes.length;
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = checked === 0;
    }

    if (this.hasSubmitLabelTarget) {
      this.submitLabelTarget.textContent =
        checked === 0 ? "Delete selected" : `Delete selected (${checked})`;
    }
  }

  confirmClear(event) {
    const count = this.boxTargets.filter((box) => box.checked).length;
    if (count === 0) {
      event.preventDefault();
      return;
    }

    const noun = count === 1 ? "booking" : "bookings";
    if (!window.confirm(`Delete ${count} ${noun}? This cannot be undone.`)) {
      event.preventDefault();
    }
  }
}
